<script>
import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import appConfig from "@/app.config";
import { loanService } from "../../../services/paymentservice/loan.service";
import List from "../../../components/list";
import Screen from "../../../components/screen";
import i18n from "../../../i18n";

/**
 * Contacts-list component
 */
export default {
  extends: Screen,
  page: {
    title: "loans List",
    meta: [{ name: "description", content: appConfig.description }]
  },
  components: { Layout, PageHeader, List },
  data() {
    return {
      ...Screen.Alert,
      ...Screen.Locate,
      loanData: {},
      typeData: {},
      fetchingStats: false,
      title: "loans List",

    };
  },
  mounted() {
    /* eslint-disable no-console */
    this.loadingData();
  },

  methods: {
    loadingData: function(param = '') {
      this.fetchingStats = false;
      loanService.getList(param)
        .then(response => {
          
          this.fetchingStats = true;
          this.loanData = response;
        });
    },

    deleted: function(id) {
      loanService.remove(id)
        .then(response => {
        
          // this.loanData = response;
          if(response.status == 200) {
            this.$swal.fire({
              title: i18n.t('general.confirm.deleted'),
              text: i18n.t('general.confirm.success'),
              icon: "success",
              confirmButtonText: i18n.t('general.ok')
            });
          }
        });
    },

    pageNavigate: function(param) {
      this.loadingData(param);
    },

    submitAdd: function() {
      this.$router.push(this.$route.query.redirectFrom || {
              name: "loan-add",
          });
    },

  }
};
</script>

<template>
  <Layout>
    <PageHeader :add="{icon: 'bx bx-add-to-queue bx-tada', title: 'general.new', link: 'loan-add'}"
    :title="$t('menuitems.loan.text')" />
    <List v-bind:dataList="loanData" 
          v-bind:edit="{link: 'loan-edit'}"
          v-bind:more="{
            sub: [{
              name: 'loan.contract', link: 'property-view'
            }]
          }"
          v-bind:filter="{
            search: ['loan.code', 'loan.customer'],
            dropdown: [],
            date: {
              title: 'general.date',
              field: 'loan.loan_date'
            }
          }"
          v-bind:deletes="[deleted, null]"
          v-bind:module="'loan'"
          v-bind:updating="fetchingStats" 
          v-bind:navigate="pageNavigate"
          v-bind:formats="[{name: 'currency_en'}, {name: 'loan_date', type: 'date'}, {name: 'expire_date', type: 'date'}, 
                    {name: 'amount', type: 'currency'}, {name: 'loan_amount', type: 'currency'}, {name: 'price', type: 'currency'}]"

          v-bind:fields="[ `code: ${$t('loan.code')}`, `loan_date: ${$t('general.date')}`, `customer: ${$t('customer.text')}`, 
            `property: ${$t('property.text')}`, `currency_en: ${$t('loan.loan-type')}`, `currency_en: ${$t('property.currency')}`, 
            `price: ${$t('loan.amount')}`, `loan_amount: ${$t('loan.paid-amount')}`, `amount: ${$t('loan.balance-principle')}`]" />
  </Layout>
</template>